import script from "./NewInfoBox.vue?vue&type=script&setup=true&lang=js"
export * from "./NewInfoBox.vue?vue&type=script&setup=true&lang=js"

import "./NewInfoBox.vue?vue&type=style&index=0&id=2fa8d206&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa8d206"]])

export default __exports__